<mic-spinner-overlay id="finished-product-spinner-overlay" ariaLabel="In Progress" color="primary" [loading]="loading" class="no-top-space">
  <mat-accordion id="finished-product-accordion" multi="true">
    <mat-expansion-panel id="rejected-casing-panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mic-icon class="mr-2" icon="error" fontSet="outlined"></mic-icon>
          {{ translationService.translate('rejectedCasingInformationText') }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      <form id="rejected-casing-form" [formGroup]="rejectedCasingForm">
        <mat-card id="rejected-casing-card" class="custom-card-no-shadow view-component">
          <div class="filter-container">
            <mat-form-field id="reject-code-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('rejectCodeText') }}</mat-label>
              <input matInput type="text" id="finished-prod-rejectCode" formControlName="rejectCode" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="reject-date-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('rejectDateText') }}</mat-label>
              <input matInput type="text" id="finished-prod-rejectDate" formControlName="rejectDate" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="reject-post-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('rejectPostText') }}</mat-label>
              <input matInput type="text" id="finished-prod-rejectPost" formControlName="rejectPost" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="reject-description-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('rejectDescriptionText') }}</mat-label>
              <input matInput type="text" id="finished-prod-rejectDesc" formControlName="rejectDescription" placeholder="-" readonly />
            </mat-form-field>
          </div>
          <div class="filter-container">
            <mat-form-field id="reject-user-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('rejectUserText') }}</mat-label>
              <input matInput type="text" id="finished-prod-rejectUser" formControlName="rejectUser" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="disposition-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('dispositionText') }}</mat-label>
              <input matInput type="text" id="finished-prod-disposition" formControlName="disposition" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="disposal-charge-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('disposalChargeText') }}</mat-label>
              <input matInput type="text" id="finished-prod-disposalCharge" formControlName="disposalCharge" placeholder="-" readonly />
            </mat-form-field>
            <mat-form-field id="disposal-charge-description-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('disposalChargeDescriptionText') }}</mat-label>
              <input
                matInput
                type="text"
                id="finished-prod-disposalChargeDesc"
                formControlName="disposalChargeDescription"
                placeholder="-"
                readonly
              />
            </mat-form-field>
          </div>
          <div class="filter-container">
            <mat-form-field id="disposal-charge-rm-part-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('disposalChargeRMPartNumberText') }}</mat-label>
              <input
                matInput
                type="text"
                id="finished-prod-disposalChargeRM"
                formControlName="disposalChargeRMPartNo"
                placeholder="-"
                readonly
              />
            </mat-form-field>
            <mat-form-field id="disposal-charge-fg-part-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('disposalChargeFGPartNumberText') }}</mat-label>
              <input
                matInput
                type="text"
                id="finished-prod-disposalChargeFG"
                formControlName="disposalChargeFGPartNo"
                placeholder="-"
                readonly
              />
            </mat-form-field>
            <mat-form-field id="reject-part-number-field" subscriptSizing="dynamic" class="filter-item">
              <mat-label> {{ translationService.translate('rejectPartNumberText') }}</mat-label>
              <input matInput type="text" id="finished-prod-rejectPartNo" formControlName="rejectPartNo" placeholder="-" readonly />
            </mat-form-field>
          </div>
        </mat-card>
      </form>
    </mat-expansion-panel>

    <mat-expansion-panel id="finished-product-panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mic-icon class="mr-2" icon="inventory" fontSet="outlined"></mic-icon>
          {{ translationService.translate('finishedProductText') }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      <mic-table
        id="finished-product-table"
        class="my-raw-materials-table btn-table"
        [config]="finishedProductConfig"
        [dataSource]="finishedProductDataSource"
      >
        <ng-container *micTableNoData>
          @if (!loading) {
          <mic-empty-state icon="layers_clear" [title]="translationService.translate('emptyTableText')"></mic-empty-state>
          }
        </ng-container>
      </mic-table>
    </mat-expansion-panel>

    <mat-expansion-panel id="raw-materials-panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mic-icon class="mr-2" icon="science" fontSet="outlined"></mic-icon>
          {{ translationService.translate('rawMaterialsText') }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      <mic-table
        id="raw-materials-table"
        class="my-raw-materials-table table-stripped btn-table"
        [config]="tableConfig"
        [dataSource]="rawMaterialsDataSource"
      >
        <ng-container *micTableNoData>
          @if (!loading) {
          <mic-empty-state icon="layers_clear" [title]="translationService.translate('emptyTableText')"></mic-empty-state>
          }
        </ng-container>
      </mic-table>
    </mat-expansion-panel>
  </mat-accordion>
</mic-spinner-overlay>
